/* eslint-disable @typescript-eslint/no-this-alias */
/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from "react";
import { string, bool, number } from "prop-types";
import Icon from "../Icon";
import "./alertMessage.scss";

export default class AlertMessage extends Component {
  static propTypes = {
    type: string.isRequired,
    title: string.isRequired,
    message: string,
    inline: bool,
    disable: bool,
    nomessage: bool,
    htmlMessage: string,
    link: string, // will show a link in the message
    showKey: number, // will increament from parent to indicate if child should reshow
  };

  static defaultProps = {
    inline: false,
    disable: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    };
    this.currentTimeout = null;
  }

  handleClose = () => {
    if (this.currentTimeout != null) {
      // prevent the timeout from still going after it is closed
      clearTimeout(this.currentTimeout);
    }
    this.setState({ isOpen: false });
  };

  typeCheck = () => {
    if (this.props.type === "Error") {
      return (
        <span className="static-error-svg">
          <Icon name="warning-18" />
        </span>
      );
    }
    if (this.props.type === "Success") {
      return (
        <span className="static-success-svg">
          <Icon name="check-lg-18" />
        </span>
      );
    }
  };
  hideAfterDelay() {
    if (this.props.type === "Success") {
      // all success messages will close with a 5 second delay
      const me = this;
      this.hideMessageActive = true;
      // below will make it show the message for 5 seconds before clearing the message
      this.currentTimeout = setTimeout(function () {
        me.setState({
          isOpen: false,
        });
        me.currentTimeout = null;
      }, 5000);
    }
  }

  checkProps = () => {
    if (this.props.showKey != null && this.props.showKey !== this.pastKey) {
      // will trigger a reshowing of this message
      this.pastKey = this.props.showKey;
      if (this.currentTimeout != null) {
        // prevent the timeout from still going after it is closed
        clearTimeout(this.currentTimeout);
      }
      this.setState({
        isOpen: true,
      });
      this.hideAfterDelay();
    }
  };

  componentDidUpdate() {
    this.checkProps();
  }
  componentDidMount() {
    this.checkProps();
  }
  render() {
    const {
      type,
      title,
      message,
      inline,
      disable,
      link,
      htmlMessage,
      nomessage,
    } = this.props;
    const infoCheck = type === "Information" ? "info" : "";
    const inlineCheck = inline ? "-inline" : "";
    const disableCheck = disable ? "disabled" : null;
    return (
      <div>
        {((this.state.isOpen &&
          title != null &&
          title.length > 0 &&
          (type === "Error" ||
            nomessage ||
            (message != null && message.length > 0) ||
            (link != null && link.length > 0))) ||
          (this.state.isOpen &&
            htmlMessage != null &&
            htmlMessage.length > 0)) && (
          <div className={`static-pe-alert${inlineCheck} static-alert-${type}`}>
            <div className="static-alert-content-container" role="alert">
              {this.typeCheck()}
              <div className={`static-alert-content-${infoCheck}`}>
                <h2 className="pe-label static-alert-title">
                  <strong>{title}</strong>
                </h2>
                <p className="pe-paragraph static-alert-text">{message}</p>
                {link != null && (
                  <div>
                    <a href={link} target="_blank" rel="noopener noreferrer">
                      {link}
                    </a>
                  </div>
                )}
                {htmlMessage && (
                  <span dangerouslySetInnerHTML={{ __html: htmlMessage }} />
                )}
              </div>
            </div>

            <button
              className="pe-icon--btn static-close-title"
              disabled={disableCheck}
              onClick={this.handleClose}
              aria-label="Close alert"
            >
              <Icon name="remove-sm-24" />
            </button>
          </div>
        )}
      </div>
    );
  }
}
